import { useEffect, useState } from "react";

/**
 * CSS 미디어쿼리 매칭 여부. 뷰포트가 바뀌면 다시 렌더된다.
 * 같은 컴포넌트를 뷰포트에 따라 다른 자리에 한 번만 렌더하고 싶을 때 쓴다
 * (CSS display:none 두 벌로 가리면 구독·연산이 두 배가 된다).
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false,
  );
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}
